// extracted by mini-css-extract-plugin
export default {"tooltip":"YM-z","arrow":"ZM-z"};